import { call, put, takeLatest } from "redux-saga/effects";
import { reportTuyenSinhApi } from "../../../api/report/reportTuyenSinhApi";
import { IReportTuyenSinhRequest } from "../../../model/request/report/IReportTuyenSinhRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IReportTuyenSinhRespone } from "../../../model/respone/report/IReportTuyenSinhRespone";
import {
  eReportTuyenSinhActionIds,
  IReportTuyenSinhActionTypes,
} from "../../action-types/report/IReportTuyenSinhActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IPagingResult } from "../../../model/respone/IPagingResult";

export function* reportTuyenSinhSaga(): any {
  yield takeLatest(eReportTuyenSinhActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IReportTuyenSinhActionTypes): any {
  const request = action.payload as IReportTuyenSinhRequest;
  const res: IBaseRespone = yield call(
    reportTuyenSinhApi.SelectByPaging,
    request,
  );
  if (res.is_success) {
    const data: IPagingResult<IReportTuyenSinhRespone[]> = res.data;
    yield put(rootActions.report.reportTuyenSinh.LOAD_SUCCESS(data));
  } else {
    yield put(
      rootActions.report.reportTuyenSinh.LOAD_ERROR(res.message ?? "Có lỗi"),
    );
  }
}
